import type { AuditActor } from '@/types/audit';

let currentActor: AuditActor | null = null;

export function setAuditActor(actor: AuditActor | null): void {
  currentActor = actor;
}

export function getAuditActor(): AuditActor | null {
  return currentActor;
}
